import * as Yup from 'yup';

export const totpCodeSchema = Yup.object().shape({
  code: Yup.string()
    .required('Enter the 6-digit code from your authenticator app.')
    .matches(/^\d{6}$/, 'Enter a complete 6-digit code from your authenticator app.'),
});

export const backupCodeSchema = Yup.object().shape({
  code: Yup.string().trim().required('Enter one of your backup codes.'),
});
